module.exports = __webpack_public_path__ + "img/3.3489e4dd.jpeg";